<template>
    <div>
        <PullContainer
            ref="pullContainerRef"
            :pullDownLoading="true"
            :pullDownLabel="true"
            @pullDownLoadingSuccess="pullDownLoadingSuccess"
        >
            <template #container>
                <div class="public_container">
                    <div class="returnNavBar">
                        <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"></ReturnNavBar>
                        <div class="returnNavBarRight" v-if="source_type !== 'unpaid_payment' && tabActiveName == '1'">
                            <span @click="handleClickBatch">批量操作</span>
                        </div>
                    </div>
                    <div class="top_search">
                        <van-search
                            v-model="searchForm.keyword"
                            placeholder="请输入查询内容"
                            @search="onSearch"
                            @clear="onSearch"
                        >
                            <template #right-icon>
                                <i class="iconfont icon-shaixuan" @click="handleClickAdvancedFilter"></i>
                            </template>
                        </van-search>
                    </div>
                    <div class="all_menu_list">
                        <ul>
                            <li
                                v-for="item in sourceList"
                                :key="item.source_type"
                                :class="{ active: source_type == item.source_type }"
                                @click="handleClickTypeChange(item)"
                            >
                                <span>{{ item.name }}</span>
                                <i class="count" v-if="item.count">{{ item.count > 99 ? "99+" : item.count }}</i>
                            </li>
                        </ul>
                        <div class="all_menu_filter_icon" @click="handleClickCategoryPickerShow">
                            <img
                                src="https://download.hecoos.com/enlightv/2024-51/4c642c0c14402f868ad37bc896bb25fb.png"
                                alt=""
                            />
                        </div>
                    </div>
                    <div class="status_wrap">
                        <div v-if="source_type == 'unpaid_payment'">
                            <span
                                v-for="status in unpaidPaymentList"
                                :key="status.unpaid_payment_type"
                                :class="{ active: status.unpaid_payment_type === unpaid_payment_type }"
                                @click="handleClickUnpaidPaymentTypeChange(status)"
                                >{{ status.name }}</span
                            >
                        </div>
                        <div v-else>
                            <span
                                v-for="status in source_type === 'order'
                                    ? statusList
                                    : statusList.filter((item) => item.value != 3)"
                                :key="status.value"
                                :class="{ active: status.value === tabActiveName }"
                                @click="handleClickStatusChange(status)"
                                >{{ status.name }}</span
                            >
                        </div>
                        <span>{{ pagination.total }}条</span>
                    </div>
                    <div class="mobile_container payable_management_container">
                        <div class="mobile_container_list">
                            <template v-if="source_type == 'unpaid_payment'">
                                <!-- 未回款列表 -->
                                <ul v-infinite-scroll="onLoadList">
                                    <li
                                        class="payable_list_item"
                                        v-for="(row, index) in tableData"
                                        :key="index"
                                        @click.stop="handleClickOrderUnpaidPaymentDetail(row)"
                                    >
                                        <div class="payable_list_item_top">
                                            <div
                                                class="mobile_list_head_user"
                                                @click.stop="handleClickUserInfo(row.salesperson_info)"
                                            >
                                                <img
                                                    :src="
                                                        row.salesperson_info && row.salesperson_info.avatar
                                                            ? row.salesperson_info.avatar
                                                            : defaultImg
                                                    "
                                                    alt=""
                                                />
                                                <span class="ellipsis">{{
                                                    row.salesperson_info && row.salesperson_info.name
                                                }}</span>
                                            </div>
                                            <span class="payable_list_item_top_time">{{ row.created_at }}</span>
                                            <span
                                                class="payable_list_item_status"
                                                :class="'payable_list_item_status_' + unpaid_payment_type"
                                                >{{ unpaid_payment_type == "unpaid" ? "未回款" : "坏账款项" }}</span
                                            >
                                        </div>
                                        <div class="payable_list_item_content">
                                            <p>
                                                <span
                                                    class="link-label"
                                                    @click.stop="handleClickOrderDetail(row.order_num)"
                                                    >{{ row.order_num }}</span
                                                >
                                            </p>
                                            <p>
                                                <template v-if="unpaid_payment_type == 'unpaid'">
                                                    <span
                                                        class="link-label"
                                                        @click.stop="
                                                            handleClickCustomerDetail(
                                                                row.customer_info.id,
                                                                row.customer_info.name
                                                            )
                                                        "
                                                        >{{
                                                            row.customer_info && row.customer_info.name
                                                                ? row.customer_info.name
                                                                : "--"
                                                        }}</span
                                                    >
                                                </template>
                                                <template v-else>
                                                    <span
                                                        class="link-label"
                                                        @click.stop="
                                                            handleClickCustomerDetail(
                                                                row.customer_id,
                                                                row.customer_name
                                                            )
                                                        "
                                                        >{{ row.customer_name || "--" }}</span
                                                    >
                                                </template>
                                            </p>
                                            <div class="payable_list_item_amount">
                                                <div>
                                                    <div class="payable_list_item_amount_percent percent_bg1">
                                                        订单总金额：¥{{ row.total_price }}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="payable_list_item_amount_percent percent_bg2">
                                                        实际回款金额：¥{{ row.repay_price }}
                                                    </div>
                                                    <div
                                                        class="payable_list_item_amount_percent percent_bg4"
                                                        v-if="unpaid_payment_type == 'unpaid'"
                                                    >
                                                        未回款金额：¥{{ row.no_repay_price }}
                                                    </div>
                                                    <div class="payable_list_item_amount_percent percent_bg3" v-else>
                                                        坏账金额：¥{{ row.bad_debt_amount }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="payable_list_item_bottom">
                                            <van-button
                                                plain
                                                size="mini"
                                                color="#2990FF"
                                                v-if="unpaid_payment_type == 'unpaid'"
                                                @click.stop="handleClickBadDebt(row)"
                                                >坏账</van-button
                                            >
                                            <van-button
                                                size="mini"
                                                color="#2990FF"
                                                v-if="unpaid_payment_type == 'unpaid'"
                                                @click.stop="handleClickDemandPayment(row)"
                                                >催款</van-button
                                            >
                                            <van-button
                                                size="mini"
                                                color="#2990FF"
                                                v-if="unpaid_payment_type == 'badDebt'"
                                                @click.stop="handleClickCancelBadDebt(row)"
                                                >取消坏账</van-button
                                            >
                                        </div>
                                    </li>
                                </ul>
                            </template>
                            <template v-else>
                                <!-- 订单回款和采购退款应收 -->
                                <ul v-infinite-scroll="onLoadList">
                                    <li
                                        class="payable_list_item"
                                        v-for="(row, index) in tableData"
                                        :key="index"
                                        @click.stop="handleClickDetail(row)"
                                    >
                                        <div class="payable_list_item_top">
                                            <div
                                                class="mobile_list_head_user"
                                                @click.stop="handleClickUserInfo(row.uid_info)"
                                            >
                                                <img
                                                    :src="
                                                        row.uid_info && row.uid_info.avatar
                                                            ? row.uid_info.avatar
                                                            : defaultImg
                                                    "
                                                    alt=""
                                                />
                                                <span class="ellipsis">{{ row.uid_info && row.uid_info.name }}</span>
                                            </div>
                                            <span class="payable_list_item_top_time">{{ row.created_at }}</span>
                                            <span
                                                class="payable_list_item_status"
                                                :class="
                                                    row.invalid_time
                                                        ? 'payable_list_item_status_invalid'
                                                        : 'payable_list_item_status' + row.status
                                                "
                                                >{{ row.invalid_time ? "已作废" : row.status_name }}</span
                                            >
                                        </div>
                                        <div class="payable_list_item_content">
                                            <p>
                                                <span
                                                    class="link-label"
                                                    @click.stop="
                                                        source_type == 'order'
                                                            ? handleClickRepaymentDetail(row)
                                                            : handleClickDetail(row)
                                                    "
                                                    >{{ row.receivable_no }}</span
                                                >
                                                <span
                                                    class="handle_icon_wrap"
                                                    v-if="row.invalid_time"
                                                    @click.stop="handleClickInvalidReasonLook(row)"
                                                >
                                                    <i class="iconfont icon-quxiaokaohe"></i>
                                                </span>
                                            </p>
                                            <p v-if="row.source_type == 'order'">
                                                {{ row.payment_company_name || "--" }}
                                            </p>
                                            <p v-else>{{ row.supplier_name || "--" }}</p>
                                            <div class="payable_list_item_amount">
                                                <div>
                                                    <div class="payable_list_item_amount_percent percent_bg1">
                                                        应收金额：¥{{ row.receivable_amount }}
                                                    </div>
                                                </div>
                                                <div v-if="row.status !== 3">
                                                    <div class="payable_list_item_amount_percent percent_bg2">
                                                        已收金额：¥{{ row.confirmed_amount }}
                                                    </div>
                                                    <div
                                                        v-if="row.invalid_time"
                                                        class="payable_list_item_amount_percent percent_bg3"
                                                    >
                                                        已作废金额：¥{{ row.receivable_amount - row.confirmed_amount }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="payable_list_item_bottom">
                                            <van-button
                                                plain
                                                size="mini"
                                                color="#2990FF"
                                                @click.stop="handleClickReject(row)"
                                                v-if="row.status == 1 && source_type === 'order'"
                                                >驳回</van-button
                                            >
                                            <van-button
                                                size="mini"
                                                color="#2990FF"
                                                v-if="row.status == 1"
                                                @click.stop="handleClickConfirm(row)"
                                                >确认</van-button
                                            >
                                            <van-button
                                                size="mini"
                                                color="#2990FF"
                                                v-if="row.status == 2 && !row.invalid_time"
                                                @click.stop="handleClickInvalid(row)"
                                                >作废</van-button
                                            >
                                        </div>
                                    </li>
                                </ul>
                            </template>
                        </div>
                    </div>
                    <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>
                    <!-- 应收菜单类型选择 -->
                    <van-overlay
                        :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
                        class-name="custom_more_overlay"
                        v-if="showCategoryPicker"
                        :show="showCategoryPicker"
                        @click="showCategoryPicker = false"
                    >
                        <div class="radio_option_wrap">
                            <div class="radio_option_item" @click="handleClickCategoryPickerClose">
                                <span>应收分类</span>
                                <van-icon name="arrow-up" />
                            </div>
                            <ul class="radio_option_list">
                                <li
                                    class="radio_option_item"
                                    v-for="item in sourceList"
                                    :key="item.source_type"
                                    @click="handleClickTypeChange(item)"
                                >
                                    <span>{{ item.name }}</span>
                                    <van-icon name="success" v-if="source_type == item.source_type" />
                                </li>
                            </ul>
                        </div>
                    </van-overlay>
                    <!-- 驳回 -->
                    <van-overlay :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }" :show="rejectDialog">
                        <div class="custom_overlay_content">
                            <div class="custom_overlay_content_title">
                                <span>驳回原因</span>
                                <van-icon name="cross" @click="handleClickRejectClose" />
                            </div>
                            <div class="custom_overlay_content_form">
                                <van-field
                                    v-model="reject_reason"
                                    rows="6"
                                    autosize
                                    label=""
                                    type="textarea"
                                    maxlength="200"
                                    placeholder="请输入驳回原因"
                                />
                                <van-button color="#2990FF" @click="handleClickRejectConfirm">确定</van-button>
                            </div>
                        </div>
                    </van-overlay>
                    <!-- 作废 -->
                    <van-overlay :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }" :show="invalidDialog">
                        <div class="custom_overlay_content">
                            <div class="custom_overlay_content_title">
                                <span>作废原因</span>
                                <van-icon name="cross" @click="handleClickInvalidClose" />
                            </div>
                            <div class="custom_overlay_content_form">
                                <van-field
                                    v-model="invalid_reason"
                                    rows="6"
                                    autosize
                                    label=""
                                    type="textarea"
                                    placeholder="请输入作废原因"
                                />
                                <van-button color="#2990FF" @click="handleClickInvalidConfirm">确定</van-button>
                            </div>
                        </div>
                    </van-overlay>
                    <!-- 催款 -->
                    <van-overlay :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }" :show="demandPaymentDialog">
                        <div class="custom_overlay_content">
                            <div class="custom_overlay_content_title">
                                <span>催款通知内容</span>
                                <van-icon name="cross" @click="handleClickDemandPaymentClose" />
                            </div>
                            <div class="custom_overlay_content_form">
                                <van-field
                                    v-model="demand_payment_content"
                                    rows="6"
                                    autosize
                                    label=""
                                    type="textarea"
                                    placeholder="请输入催款通知内容"
                                />
                                <van-button color="#2990FF" @click="handleClickDemandPaymentConfirm">确定</van-button>
                            </div>
                        </div>
                    </van-overlay>
                    <!-- 作废原因展示弹框 -->
                    <van-overlay :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }" :show="invalidReasonLookDialog">
                        <div class="custom_overlay_content">
                            <div class="custom_overlay_content_title">
                                <span>作废原因</span>
                                <van-icon name="cross" @click="handleClickInvalidReasonLookClose" />
                            </div>
                            <div class="custom_overlay_content_form">
                                <van-field v-model="invalid_reason" autosize label="" type="textarea" />
                            </div>
                        </div>
                    </van-overlay>
                </div>
            </template>
        </PullContainer>
        <userDetailDialog
            v-if="userDetailPopupShow"
            :userDetailPopupShow.sync="userDetailPopupShow"
            :userId="userDetailId"
        />
        <ListAdvancedFiltering
            v-if="searchPopupShow"
            ref="listAdvancedFiltering"
            :system_fields.sync="systemFilterFields"
            @sendFilterData="getFilterData"
        />
    </div>
</template>
<script>
import {
    ReceivableList,
    ReceivableBatchReject,
    ReceivableInvalid,
    OrderUnpaidList,
    OrderBadDebtList,
    OrderCancelBadDebt,
} from "@/api";
import { pagination } from "@/mixins";
import { mapState } from "vuex";
import { Dialog } from "vant";
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
import userDetailDialog from "@/components/mComponents/userDetailDialog";
import ListAdvancedFiltering from "../component/ListAdvancedFiltering.vue";
export default {
    name: "ReceivableManage",
    components: {
        PullContainer,
        ReturnNavBar,
        FooterTabbar,
        userDetailDialog,
        ListAdvancedFiltering,
    },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            searchForm: {
                keyword: "",
            },
            source_type: "order", // 来源类型
            sourceList: [
                { name: "订单回款应收", source_type: "order" },
                { name: "采购退款应收", source_type: "purchase_refund" },
                { name: "订单未回款明细", source_type: "unpaid_payment" },
                { name: "应收统计", type: "statistics" },
            ],
            showCategoryPicker: false,
            tabActiveName: "1",
            statusList: [
                { value: "1", name: "待确认" },
                { value: "2", name: "已确认" },
                { value: "3", name: "已驳回" },
            ],
            // 未回款明细分类
            unpaid_payment_type: "unpaid",
            unpaidPaymentList: [
                { name: "未回款", unpaid_payment_type: "unpaid" },
                { name: "坏账款项", unpaid_payment_type: "badDebt" },
            ],
            tableData: [],
            // 驳回
            rejectDialog: false,
            reject_reason: "",
            // 作废
            invalidDialog: false,
            invalid_reason: "",
            // 复选框选中的数据
            handleDialogIds: [],
            // 催款
            demandPaymentDialog: false,
            demand_payment_content: "",
            // 作废原因弹框
            invalidReasonLookDialog: false,
            tabBarList: [
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "FinanceManagement",
                    title: "首页",
                },
                {
                    icon: "icon-mobile-yingfu",
                    activeIcon: "icon-mobile-yingfu",
                    routerName: "PayableManage",
                    title: "应付",
                },
                {
                    icon: "icon-yingshou",
                    activeIcon: "icon-yingshouxuanzhong",
                    routerName: "ReceivableManage",
                    title: "应收",
                },
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "InvoiceManage",
                    title: "开票",
                },
            ],
            tabBarActive: 2,
            custom_filter: {}, // 高级筛选确认条件
            // 人员详细信息
            userDetailPopupShow: false,
            userDetailId: "",
            payTypeList: [
                { label: "电汇", value: 1 },
                { label: "微信", value: 2 },
                { label: "支付宝", value: 3 },
                { label: "现金", value: 4 },
                { label: "银行承兑", value: 5 },
                { label: "商业承兑", value: 6 },
                { label: "支票", value: 7 },
            ],
        };
    },
    mixins: [pagination],
    computed: {
        ...mapState(["searchPopupShow"]),
        systemFilterFields() {
            if (this.source_type == "unpaid_payment") {
                if (this.unpaid_payment_type == "unpaid") {
                    return [
                        {
                            field_type: "contact",
                            field_key: "salesperson_ids",
                            is_system: 1,
                            field_name: "订单负责人",
                            system_type: "system",
                            field_value_type: "array",
                        },
                        {
                            field_type: "contact",
                            field_key: "department_head_ids",
                            is_system: 1,
                            field_name: "部门负责人",
                            system_type: "system",
                            field_value_type: "array",
                        },
                    ];
                } else {
                    return [
                        {
                            field_type: "contact",
                            field_key: "salesperson_ids",
                            is_system: 1,
                            field_name: "订单负责人",
                            system_type: "system",
                            field_value_type: "array",
                        },
                        {
                            field_type: "contact",
                            field_key: "department_head_ids",
                            is_system: 1,
                            field_name: "部门负责人",
                            system_type: "system",
                            field_value_type: "array",
                        },
                        {
                            field_type: "contact",
                            field_key: "operator_ids",
                            is_system: 1,
                            field_name: "处理人",
                            system_type: "system",
                            field_value_type: "array",
                        },
                        {
                            field_type: "date_range",
                            field_key: "operate_date",
                            is_system: 1,
                            field_name: "处理日期",
                            system_type: "system",
                            field_value_type: "array",
                        },
                    ];
                }
            } else {
                if (this.tabActiveName == 1) {
                    return [
                        {
                            field_type: "contact",
                            field_key: "uid",
                            is_system: 1,
                            field_name: "申请人",
                            system_type: "system",
                            field_value_type: "int",
                        },
                        {
                            field_type: "date_range",
                            field_key: "apply_time_range",
                            is_system: 1,
                            field_name: "创建时间",
                            system_type: "system",
                            field_value_type: "array",
                        },
                    ];
                } else if (this.tabActiveName == 2) {
                    return [
                        {
                            field_type: "contact",
                            field_key: "uid",
                            is_system: 1,
                            field_name: "申请人",
                            system_type: "system",
                            field_value_type: "int",
                        },
                        {
                            field_type: "date_range",
                            field_key: "confirm_time_range",
                            is_system: 1,
                            field_name: "确认时间",
                            system_type: "system",
                            field_value_type: "array",
                        },
                        {
                            field_type: "checkbox",
                            field_key: "payment_method",
                            is_system: 1,
                            field_name: "收款方式",
                            system_type: "system",
                            field_value_type: "int",
                            options: this.payTypeList,
                        },
                    ];
                } else {
                    return [
                        {
                            field_type: "contact",
                            field_key: "uid",
                            is_system: 1,
                            field_name: "申请人",
                            system_type: "system",
                            field_value_type: "int",
                        },
                        {
                            field_type: "date_range",
                            field_key: "reject_time_range",
                            is_system: 1,
                            field_name: "驳回时间",
                            system_type: "system",
                            field_value_type: "array",
                        },
                    ];
                }
            }
        },
    },
    created() {
        this.source_type = (this.$route.query && this.$route.query.source_type) ? this.$route.query.source_type : "order";
        this.tabActiveName = (this.$route.query && this.$route.query.tab) ? this.$route.query.tab : "1";
        this.tableData = [];
        this.onSearch();
    },
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.pullDownLoading = true;
                this.onSearch();
            }
        },
        // 点击高级筛选
        handleClickAdvancedFilter() {
            this.$store.dispatch("searchPopupShow", true);
        },
        // 获取高级筛选数据
        getFilterData(data) {
            this.custom_filter = data;
            this.$store.dispatch("searchPopupShow", false);
            this.onSearch();
        },
        // 分类切换弹框
        handleClickCategoryPickerShow() {
            this.showCategoryPicker = true;
        },
        // 分类切换
        handleClickTypeChange(item) {
            if (item.type && item.type == "statistics") {
                this.$router.push({
                    name: "ReceivableStatistics",
                });
            } else {
                this.source_type = item.source_type;
                this.showCategoryPicker = false;
                this.custom_filter.custom_field = [];
                if (this.source_type === "unpaid_payment") {
                    // 订单未回款明细
                    this.unpaid_payment_type = "unpaid";
                } else {
                    this.tabActiveName = "1";
                }
                this.onSearch();
            }
        },
        // 订单未回款明细二级菜单切换
        handleClickUnpaidPaymentTypeChange(item) {
            this.unpaid_payment_type = item.unpaid_payment_type;
            this.onSearch();
        },
        handleClickCategoryPickerClose() {
            this.showCategoryPicker = false;
        },
        // 状态切换
        handleClickStatusChange(status) {
            this.tabActiveName = status.value;
            this.custom_filter.custom_field = [];
            this.onSearch();
        },
        // 驳回
        handleClickReject(row) {
            this.handleDialogIds = [row.receivable_no];
            this.rejectDialog = true;
        },
        // 驳回弹框关闭
        handleClickRejectClose() {
            this.handleDialogIds = [];
            this.reject_reason = "";
            this.rejectDialog = false;
        },
        // 驳回确认
        handleClickRejectConfirm() {
            if (!this.reject_reason) return this.$toast("请输入驳回原因");
            ReceivableBatchReject({ receivable_nos: this.handleDialogIds, reject_reason: this.reject_reason }).then(
                (res) => {
                    if (res.code == 200) {
                        this.$toast({
                            message: res.message,
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                this.handleClickRejectClose();
                                this.onSearch();
                            },
                        });
                    } else {
                        this.$message.error(res.message);
                    }
                }
            );
        },
        // 作废
        handleClickInvalid(row) {
            this.handleDialogIds = row.receivable_no;
            this.invalidDialog = true;
        },
        // 作废弹框关闭
        handleClickInvalidClose() {
            this.handleDialogIds = [];
            this.invalid_reason = "";
            this.invalidDialog = false;
        },
        // 作废确认
        handleClickInvalidConfirm() {
            if (!this.invalid_reason) return this.$toast("请输入作废原因");
            ReceivableInvalid({ receivable_no: this.handleDialogIds, invalid_reason: this.invalid_reason }).then(
                (res) => {
                    if (res.code == 200) {
                        this.$toast({
                            message: res.message,
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                this.handleClickInvalidClose();
                                this.onSearch();
                            },
                        });
                    } else {
                        this.$message.error(res.message);
                    }
                }
            );
        },
        // 作废原因查看弹框
        handleClickInvalidReasonLook(row) {
            this.invalid_reason = row.invalid_reason;
            this.invalidReasonLookDialog = true;
        },
        handleClickInvalidReasonLookClose() {
            this.invalidReasonLookDialog = false;
            this.invalid_reason = "";
        },
        // 催款
        handleClickDemandPayment(row) {
            this.handleDialogIds = [row.order_num];
            this.demandPaymentDialog = true;
        },
        // 催款弹框关闭
        handleClickDemandPaymentClose() {
            this.handleDialogIds = [];
            this.demand_payment_content = "";
            this.demandPaymentDialog = false;
        },
        // 催款确认
        handleClickDemandPaymentConfirm() {
            if (!this.demand_payment_content) return this.$toast("请输入催款通知内容");
            const params = {
                order_nums: this.handleDialogIds,
                content: this.demand_payment_content,
            };
            OrderUrgePayment(params).then((res) => {
                if (res.code == 200) {
                    this.$toast({
                        message: res.message,
                        type: "success",
                        duration: 1000,
                        onClose: () => {
                            this.handleClickDemandPaymentClose();
                            this.onSearch();
                        },
                    });
                }
            });
        },
        // 确认
        handleClickConfirm(row) {
            this.$router.push({
                name: "PaymentConfirmation",
                query: {
                    receivable_no: row.receivable_no,
                    confirmType: "confirm",
                    source_type: this.source_type,
                },
            });
        },
        // 查看应收详情
        handleClickDetail(row) {
            this.$router.push({
                name: "ReceivableDetails",
                query: {
                    receivable_no: row.receivable_no,
                },
            });
        },
        // 查看回款详情
        handleClickRepaymentDetail(row) {
            this.$router.push({
                name: "RepaymentDetails",
                query: {
                    receivable_no: row.receivable_no,
                },
            });
        },
        // 查看客户详情
        handleClickCustomerDetail(customer_id, customer_name) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id,
                    name: customer_name,
                },
            });
        },
        // 坏账
        handleClickBadDebt(row) {
            this.$router.push({
                name: "BadDebt",
                query: {
                    order_num: row.order_num,
                    order_detail: {
                        total_price: row.total_price,
                        total_repay_price: row.total_repay_price,
                        no_repay_price: row.no_repay_price,
                    },
                },
            });
        },
        // 取消坏账
        handleClickCancelBadDebt(row) {
            Dialog.confirm({
                title: "取消坏账",
                message: "是否要对该条取消坏账操作，取消后该条数据恢复到未回款中，是否继续？",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
                confirmButtonText: "确定",
            })
                .then(() => {
                    const params = { order_num: row.order_num };
                    OrderCancelBadDebt(params).then((res) => {
                        if (res.code === 200) {
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.getBadDebtList();
                                },
                            });
                        }
                        this.loading = false;
                    });
                })
                .catch(() => {
                    // on cancel
                });
        },
        // 批量操作
        handleClickBatch() {
            this.$router.push({
                name: "ReceivableChoose",
                query: {
                    source_type: this.source_type,
                    payment_status: this.tabActiveName,
                },
            });
        },
        // 订单详情
        handleClickOrderDetail(order_no) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: order_no,
                    name: order_no,
                    query_type: "order_no",
                },
            });
        },
        // 订单未回款详情
        handleClickOrderUnpaidPaymentDetail(row) {
            this.$router.push({
                name: "UnpaidPaymentDetails",
                query: {
                    order_num: row.order_num,
                },
            });
        },
        // 人员详细信息
        handleClickUserInfo(info) {
            this.userDetailId = info.id;
            this.userDetailPopupShow = true;
        },
        onSearch() {
            this.pagination.pageNum = 1;
            this.tableData = [];
            this.getMoreTypeData();
        },
        // 加载更多
        onLoadList() {
            if (this.pagination.total == this.tableData.length) {
                return false;
            }
            if (this.loading == false) {
                this.getMoreTypeData();
            }
        },
        // 加载数据类型
        getMoreTypeData() {
            if (this.source_type === "unpaid_payment") {
                // 订单未回款明细
                if (this.unpaid_payment_type === "unpaid") {
                    // 未回款
                    this.getOrderUnpaidList();
                } else {
                    // 坏账
                    this.getBadDebtList();
                }
            } else {
                // 订单退款应收 和 采购退款应收
                this.getTableData();
            }
        },
        // 订单退款应收和采购应收
        getTableData() {
            this.loading = true;
            let params = {
                source_type: this.source_type,
                status: this.tabActiveName,
                page: this.pagination.pageNum,
                pageSize: 10, // this.pagination.pageSize
                keyword: this.searchForm.keyword,
            };
            if (this.custom_filter.custom_field && this.custom_filter.custom_field.length) {
                this.custom_filter.custom_field.forEach((option) => {
                    params[option.field_key] =
                        option.field_value_type == "int" ? option.field_value[0] : option.field_value;
                });
            }
            ReceivableList(params)
                .then((res) => {
                    if (res.code == 200) {
                        const { data, total } = res.data;
                        this.tableData = this.tableData.concat(data);
                        this.pagination.total = total;
                        this.pagination.pageNum++;
                        this.loading = false;
                        if (this.pullDownLoading) {
                            this.pullDownLoading = false;
                            this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                        }
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 获取订单未回款明细
        getOrderUnpaidList() {
            this.loading = true;
            let params = {
                page: this.pagination.pageNum,
                pageSize: 10, // this.pagination.pageSize
                keyword: this.searchForm.keyword,
            };
            if (this.custom_filter.custom_field && this.custom_filter.custom_field.length) {
                this.custom_filter.custom_field.forEach((option) => {
                    params[option.field_key] =
                        option.field_value_type == "int" ? option.field_value[0] : option.field_value;
                });
            }
            OrderUnpaidList(params)
                .then((res) => {
                    if (res.code == 200) {
                        const { data, total } = res.data;
                        this.tableData = this.tableData.concat(data);
                        this.pagination.total = total;
                        this.pagination.pageNum++;
                        this.loading = false;
                        if (this.pullDownLoading) {
                            this.pullDownLoading = false;
                            this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                        }
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 获取订单未回款坏账明细
        getBadDebtList() {
            this.loading = true;
            let params = {
                page: this.pagination.pageNum,
                pageSize: 10, // this.pagination.pageSize
                keyword: this.searchForm.keyword,
            };
            if (this.custom_filter.custom_field && this.custom_filter.custom_field.length) {
                this.custom_filter.custom_field.forEach((option) => {
                    params[option.field_key] =
                        option.field_value_type == "int" ? option.field_value[0] : option.field_value;
                });
            }
            OrderBadDebtList(params)
                .then((res) => {
                    if (res.code == 200) {
                        const { data, total } = res.data;
                        this.tableData = this.tableData.concat(data);
                        this.pagination.total = total;
                        this.pagination.pageNum++;
                        this.loading = false;
                        if (this.pullDownLoading) {
                            this.pullDownLoading = false;
                            this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                        }
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.returnNavBarRight {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 22px;
    color: rgba(41, 144, 255, 1);
}

.all_menu_list {
    margin-top: -4px;
    height: 42px;
    opacity: 1;
    background: rgba(255, 255, 255, 1);
    display: flex;
    align-items: center;
    justify-content: space-between;

    ul {
        height: 100%;
        padding: 0 7px 0 16px;
        overflow-x: auto;
        display: flex;
        gap: 10px;

        li {
            flex: auto;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 42px;
            color: rgba(102, 102, 102, 1);
            text-align: center;
            white-space: nowrap;
            position: relative;
            span {
                line-height: 22px;
            }

            &.active {
                font-weight: 700;
                color: rgba(25, 144, 255, 1);

                &::after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    margin-left: -10px;
                    width: 20px;
                    height: 2px;
                    border-radius: 1px 1px, 0px, 0px;
                    background: rgba(41, 144, 255, 1);
                }
            }

            .count {
                position: absolute;
                top: 5px;
                right: 1px;
                padding: 0 4px;
                min-width: 18px;
                height: 18px;
                line-height: 16px;
                text-align: center;
                border: 1px solid #ffffff;
                font-size: 10px;
                font-weight: 500;
                color: #ffffff;
                border-radius: 10px;
                background-color: rgb(228, 65, 68);
            }
        }
    }

    .all_menu_filter_icon {
        flex-shrink: 0;
        padding: 0 16px;

        img {
            width: 16px;
        }
    }
}

.radio_option_wrap {
    width: 100%;
    min-height: 220px;
    max-height: 50%;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;

    .radio_option_item {
        padding: 10px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(51, 51, 51, 1);
        }

        .van-icon {
            color: rgba(51, 51, 51, 1);
            font-size: 12px;
        }
    }

    .radio_option_list {
        flex: 1;
        overflow-y: auto;

        .radio_option_item {
            span {
                color: rgba(102, 102, 102, 1);
            }

            .van-icon {
                color: rgba(25, 144, 255, 1);
            }
        }
    }
}

.custom_more_overlay {
    top: 44px !important;
}

.status_wrap {
    padding: 10px 16px 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > div {
        span {
            display: inline-block;
            vertical-align: top;
            width: 68px;
            height: 26px;
            text-align: center;
            line-height: 26px;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            color: rgba(102, 102, 102, 1);
            border-radius: 4px;
            background: rgba(255, 255, 255, 1);

            & + span {
                margin-left: 10px;
            }

            &.active {
                color: rgba(41, 144, 255, 1);
                border: 1px solid rgba(41, 144, 255, 0.5);
                background: rgba(41, 144, 255, 0.1);
            }
        }
    }

    & > span {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 18px;
        color: rgba(153, 153, 153, 1);
    }
}

.payable_management_container {
    .mobile_container_list {
        padding: 0 16px 8px;

        .payable_list_item {
            width: 100%;
            padding: 12px;
            border-radius: 6px;
            background: rgba(255, 255, 255, 1);
            margin-bottom: 8px;

            .payable_list_item_top {
                padding-bottom: 10px;
                display: flex;
                align-items: center;
                position: relative;

                & > span {
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 18px;
                    color: rgba(153, 153, 153, 1);
                }

                .link-label {
                    color: rgba(41, 144, 255, 1);
                }

                .payable_list_item_status {
                    position: absolute;
                    top: 2px;
                    right: 0;
                    width: 64px;
                    height: 22px;
                    text-align: center;
                    line-height: 22px;
                    font-size: 12px;
                    font-weight: 400;
                    border-radius: 6px;

                    &.payable_list_item_status1 {
                        color: rgba(240, 170, 50, 1);
                        background: rgba(240, 170, 50, 0.15);
                    }

                    &.payable_list_item_status2 {
                        color: rgba(90, 179, 51, 1);
                        background-color: rgba(90, 179, 51, 0.15);
                    }

                    &.payable_list_item_status3,
                    &.payable_list_item_status_unpaid,
                    &.payable_list_item_status_badDebt,
                    &.payable_list_item_status_invalid {
                        color: rgba(153, 153, 153, 1);
                        background-color: rgba(153, 153, 153, 0.15);
                    }
                }
            }

            .payable_list_item_content {
                p {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(102, 102, 102, 1);
                    margin-bottom: 4px;

                    .link-label {
                        color: rgba(41, 144, 255, 1);
                    }
                }

                .payable_list_item_amount {
                    width: 100%;
                    padding: 4px;
                    border-radius: 4px;
                    background: #ffffff;
                    border: 2px solid rgba(237, 240, 244, 1);

                    & > div {
                        height: 24px;
                        display: flex;
                        justify-content: space-between;
                        gap: 4px;
                    }

                    & > div + div {
                        margin-top: 4px;
                    }

                    .payable_list_item_amount_percent {
                        width: 100%;
                        height: 24px;
                        padding: 0 8px;
                        font-size: 12px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 24px;
                        color: rgba(102, 102, 102, 1);
                        border-radius: 4px;
                        box-sizing: border-box;
                    }

                    .percent_bg1 {
                        background-color: rgba(41, 144, 255, 0.16);
                    }

                    .percent_bg2 {
                        background-color: rgba(41, 144, 255, 0.08);
                        padding-right: 0;
                    }

                    .percent_bg3 {
                        background-color: rgba(228, 65, 68, 0.08);
                        color: rgba(228, 65, 68, 1);
                        font-weight: 700;
                        text-align: right;
                        padding-left: 0;
                    }

                    .percent_bg4 {
                        background-color: rgba(0, 0, 0, 0.04);
                        color: rgba(51, 51, 51, 1);
                        font-weight: 700;
                        text-align: right;
                        padding-left: 0;
                    }
                }

                .handle_icon_wrap {
                    margin-left: 4px;
                    color: rgba(228, 65, 68, 1);
                }
            }

            .payable_list_item_bottom {
                margin-top: 10px;
                display: flex;
                justify-content: flex-end;

                .van-button {
                    padding: 0 7px;
                    border-radius: 4px;
                    font-size: 12px;
                }
            }
        }
    }
}
</style>
